import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store';
import ReportingTool from '@/components/ReportingTool.vue'
import AdvertDashboard from '@/components/AdvertDashboard.vue'
import AdminDashboard from '@/components/AdminDashboard.vue'
Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next({name:'home'})
    return
  }
  next()
}

const ifAdminUser = (to, form, next) => {
  if (!store.getters.isAdminUser) {
    next({name:'home'})
    return
  }
  next()
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path:'staff-page',
          name: 'adminPage',
          component: AdminDashboard,
          beforeEnter: ifAdminUser,
          meta: {
            onlyAdmin: true
          }
        },
        {
          path:'staff-reporting-tool',
          name: 'adminReportingTool',
          component: ReportingTool,
          beforeEnter: ifAdminUser,
          meta: {
            onlyAdmin: true
          }
        },
        {
          path:'advertiser-page',
          name: 'advertPage',
          component: AdvertDashboard,
          meta: {
            onlyAdmin: false
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter: ifAuthenticated,
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    { path: '*', redirect: '/' }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // redirect to login page if not logged in and trying to access a restricted page
    if (store.getters.isLoggedIn) {
      // redirect to admin/adver page depending on user type
      if (store.getters.isAdminUser) {
        if (from.name === 'login' || !from.name) {
          next()
          next({name:'adminPage'})
        }
        next()
      } else {
        next()
        next({name:'advertPage'})
      }
    } else {
      next({name: 'login'})
    }
    return
  }
  next()
})

export default router